module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-b8abcac6.png";